import { useEffect } from 'react'

const ImplementationsQuestion = ({ formData, setFormData, questionState, setQuestionState }) => {

    useEffect(() => {
        const existingResponses = formData.form_responses?.question4?.responses || [];
        if (existingResponses.length > 0) {
            const newState = { ...questionState };

            existingResponses.forEach(response => {
                if (newState[response.answer_text]) {
                    newState[response.answer_text].selected = true;

                    if (response.text_response) {
                        newState[response.answer_text].text_response = response.text_response;
                    }
                }
            });

            setQuestionState(newState);
        }
    }, [formData.form_responses?.question4?.responses])

    const handleQuestionUpdate = (responseKey, checkedValue, parentKey = null, dataKey = null, value = null) => {
        setQuestionState(prevState => {
            const newState = { ...prevState };

            if (dataKey) {
                newState[responseKey] = {
                    ...newState[responseKey],
                    [dataKey]: value
                };
            } else {
                newState[responseKey] = {
                    ...newState[responseKey],
                    selected: checkedValue
                };
            }

            return newState;
        });

        setFormData(prevFormData => {
            const currentResponses = prevFormData.form_responses?.question4?.responses || [];

            if (dataKey) {
                const updatedResponses = currentResponses.map(response =>
                    response.answer_text === responseKey
                        ? { ...response, [dataKey]: value }
                        : response
                );

                return {
                    ...prevFormData,
                    form_responses: {
                        ...prevFormData.form_responses,
                        question4: {
                            question_title: "What actions have been implemented?",
                            responses: updatedResponses
                        }
                    }
                };
            } else {
                let updatedResponses = [...currentResponses];

                if (checkedValue) {
                    if (!updatedResponses.find(r => r.answer_text === responseKey)) {
                        updatedResponses.push({
                            answer_text: responseKey,
                            sub_responses: []
                        });
                    }
                } else {
                    updatedResponses = updatedResponses.filter(r => r.answer_text !== responseKey);
                }

                return {
                    ...prevFormData,
                    form_responses: {
                        ...prevFormData.form_responses,
                        question4: {
                            question_title: "What actions have been implemented?",
                            responses: updatedResponses
                        }
                    }
                };
            }
        });
    };

    const hasResponse = (responseKey) => {
        return questionState[responseKey]?.selected || false;
    };

    const getResponseData = (responseKey, dataKey) => {
        return questionState[responseKey]?.[dataKey] || '';
    };
    return (
        <div className="mt-6 border border-gray-200 rounded-lg">
            <div className="flex items-center justify-between p-4 bg-blue-50 rounded-t-lg">
                <h2 className="text-lg font-semibold text-gray-800">
                    Step 5: What actions have been implemented?
                </h2>
                <span className="text-red-500 text-sm font-medium">Required *</span>
            </div>
            <div>
                <div className="p-2">
                    <div className="space-y-2">
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="temp_adjustments"
                                value="Temporary Adjustments"
                                className="mr-2"
                                onChange={(e) => handleQuestionUpdate('Temporary Adjustments', e.target.checked)}
                                checked={hasResponse('Temporary Adjustments')}
                            />
                            <label htmlFor="temp_adjustments" className="text-sm text-gray-700">Temporary Adjustments</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="perm_adjustments"
                                value="Permanent Adjustments"
                                className="mr-2"
                                onChange={(e) => handleQuestionUpdate('Permanent Adjustments', e.target.checked)}
                                checked={hasResponse('Permanent Adjustments')}
                            />
                            <label htmlFor="perm_adjustments" className="text-sm text-gray-700">Permanent Adjustments</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="reduced_hours"
                                value="Reduced Hours"
                                className="mr-2"
                                onChange={(e) => handleQuestionUpdate('Reduced Hours', e.target.checked)}
                                checked={hasResponse('Reduced Hours')}
                            />
                            <label htmlFor="reduced_hours" className="text-sm text-gray-700">Reduced Hours</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="phased_return"
                                value="Phased Return To Work"
                                className="mr-2"
                                onChange={(e) => handleQuestionUpdate('Phased Return To Work', e.target.checked)}
                                checked={hasResponse('Phased Return To Work')}
                            />
                            <label htmlFor="phased_return" className="text-sm text-gray-700">Phased Return To Work</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="redeployment"
                                value="Redeployment"
                                className="mr-2"
                                onChange={(e) => handleQuestionUpdate('Redeployment', e.target.checked)}
                                checked={hasResponse('Redeployment')}
                            />
                            <label htmlFor="redeployment" className="text-sm text-gray-700">Redeployment</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="other_actions"
                                value="Other"
                                className="mr-2"
                                onChange={(e) => handleQuestionUpdate('Other', e.target.checked)}
                                checked={hasResponse('Other')}
                            />
                            <label htmlFor="other_actions" className="text-sm text-gray-700">Other (Please State)</label>
                        </div>
                    </div>
                    {hasResponse('Other') && (
                        <div className="mt-2 ml-6">
                            <textarea
                                id="actionsOther"
                                name="actionsOther"
                                rows="2"
                                className="border rounded-md py-2 px-4 w-full resize-vertical"
                                placeholder="Please specify other actions..."
                                onChange={(e) => handleQuestionUpdate('Other', null, null, 'text_response', e.target.value)}
                                value={getResponseData('Other', 'text_response')}
                            ></textarea>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ImplementationsQuestion;